module.exports = __webpack_public_path__ + "img/upsell-free-mobile.709c0af.jpg";